// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35d01ba6","732":"18ab4880","977":"4ebc3c45"}[chunkId] + ".chunk.js";
};